// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 779) return "static/chunks/779-81ee74974f067254.js";
	if (chunkId === 572) return "static/chunks/572-0b1c16057613ddbd.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"434":"d934ae615cb3e898","668":"fb2654a1f3c24151","878":"85079017cc473e6b"}[chunkId] + ".js";
};